<template>
	<modal
		ref="ref"
		:name="name"
		:width="width"
		:minWidth="minWidth"
		:clickToClose="clickToClose"
		@opened="opened"
		v-on="$listeners"
		v-bind="$attrs"
		height="auto"
	>
		<modals-confirmation-header v-if="isConfirmation" :name="name" :canClose="clickToClose" />
		<modals-header v-else-if="$slots.header || headerText" :name="name" :canClose="clickToClose">
			<slot name="header">
				{{ headerText }}
			</slot>
		</modals-header>

		<slot />
	</modal>
</template>

<script>
export default {
	inheritAttrs: false,
	props: {
		name: {
			type: String,
			required: true,
		},
		width: {
			type: Number,
			required: false,
			default: 600,
		},
		minWidth: {
			type: Number,
			required: false,
			default: null,
		},
		clickToClose: {
			type: Boolean,
			default() {
				return true;
			},
		},
		/**
		 * Optional header text for this modal.
		 * Can optionally use the header slot.
		 */
		headerText: {
			type: String,
			default: '',
		},
		isConfirmation: Boolean,
		/**
		 * Array of $refs sent from children.
		 *
		 * @type {Object}
		 */
		childRefs: {
			type: Object,
			default() {
				return null;
			},
		},
	},
	methods: {
		opened() {
			if (this.childRefs && this.childRefs.toFocus) {
				const getFocusRef = (refs) => {
					while (refs.toFocus && refs.toFocus.$refs) {
						refs = refs.toFocus.$refs;
					}

					return refs.toFocus;
				};
				this.$nextTick(() => {
					const el = getFocusRef(this.childRefs);
					if (el && el.focus) {
						el.focus();
					}
				});
			}
		},
	},
};
</script>

<style lang="scss">
body .v--modal-overlay {
	background: rgba(255, 255, 255, 0.7);

	.v--modal {
		color: #41495b;
		border-radius: 5px;

		&-box {
			overflow: visible;
		}

		.header {
			color: #fff;
			background: #41495b;
			padding: 14px 20px;
			font-size: 18px;
			font-weight: 700;
			display: flex;
			align-items: center;
			max-height: 50px;
			border-radius: 5px 5px 0 0;

			svg {
				width: 20px;
				margin-right: 10px;
			}

			.close {
				color: #fff;
				display: flex;
				flex-grow: 1;
				max-height: 50px;
				justify-content: flex-end;
				align-items: center;

				button {
					display: flex;
					align-items: center;
				}

				svg {
					width: 16px !important;
					height: 16px;
					margin-right: 0;
					cursor: pointer;
				}
			}
		}

		.content {
			padding: 20px;
		}
	}
}
</style>
